/* =============================================================================
 * Hot Box Pretzels — Scratch & Win pop-up  (Shopify theme `assets/custom.js`)
 * -----------------------------------------------------------------------------
 * This is the REWIRED version of the pop-up that lives in the Shopify theme
 * "Scratch & Win Popup — DRAFT". It is identical in look + behaviour to the
 * original, with ONE change: it no longer posts signups to Klaviyo. Instead it
 * POSTs to the Pretzel backend (`captureLead` Cloud Function), which:
 *   - stores the lead + per-channel consent,
 *   - sends the welcome email with the discount code via RESEND,
 *   - sends the optional SMS via Twilio,
 *   - returns the discount code (used to auto-apply on "Shop now").
 *
 * To deploy: replace the theme's `assets/custom.js` with this file
 * (Online Store → Themes → ⋯ Edit code → assets/custom.js → paste → Save).
 * The discount code + welcome email copy are configured in the dashboard:
 * Marketing → Popup builder (writes popupConfigs/default). Prize shown = "10% OFF",
 * code delivered = whatever popupConfigs.discountCode is set to (e.g. SCRATCH10).
 * ===========================================================================*/
(function () {
"use strict";
if (window.__hbpLoaded) return;
window.__hbpLoaded = true;
var CFG = {
LOGO_URL:  "https://cdn.shopify.com/s/files/1/0578/6897/6192/files/hbp-popup-logo.png?v=1780364061",
PHOTO_URL: "https://cdn.shopify.com/s/files/1/0578/6897/6192/files/hbp-popup-photo.jpg?v=1780362916", // oven+pretzels background (embedded)
CAPTURE_ENDPOINT: "https://us-central1-pretzel-business.cloudfunctions.net/captureLead", // Pretzel backend -> Resend email + Twilio SMS
STORE_ID:  "default",   // matches the popupConfigs/{storeId} doc in the dashboard
SOURCE:    "Scratch & Win Pop-Up",
DELAY_MS:  1500
};
if (window.HBP_PHOTO_URL) CFG.PHOTO_URL = window.HBP_PHOTO_URL;
if (window.HBP_LOGO_URL)  CFG.LOGO_URL  = window.HBP_LOGO_URL;
var photoLayer = CFG.PHOTO_URL
? "url('" + CFG.PHOTO_URL + "') center bottom / cover no-repeat, #00070E"
: "radial-gradient(120% 90% at 50% 120%, #15202b 0%, #00070E 60%)";
var CSS = [
"#hbpOverlay{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,3,8,.72);opacity:1;transition:opacity .28s ease;font-family:'TAY Milkbar','Baloo 2','Arial Black',sans-serif}",
"#hbpOverlay[aria-hidden='true']{opacity:0;pointer-events:none}",
"#hbpOverlay *{box-sizing:border-box}",
".hbp-pop{position:relative;width:min(92vw,420px);min-height:min(640px,92vh);max-height:94vh;display:flex;flex-direction:column;background:#00070E;border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.6)}",
".hbp-photo{position:absolute;inset:0;z-index:0;background:" + photoLayer + "}",
".hbp-photo::after{content:'';position:absolute;inset:0;background:linear-gradient(to bottom,rgba(0,7,14,.93) 0%,rgba(0,7,14,.8) 20%,rgba(0,7,14,.5) 42%,rgba(0,7,14,.26) 60%,rgba(0,7,14,.24) 80%,rgba(0,7,14,.46) 100%)}",
".hbp-content{position:relative;z-index:2;flex:1 1 auto;display:flex;flex-direction:column;align-items:center;text-align:center;padding:26px 26px 34px;overflow:auto}",
".hbp-close{position:absolute;top:10px;right:12px;z-index:5;width:30px;height:30px;border-radius:50%;border:0;cursor:pointer;line-height:1;font-size:20px;color:#FFF4B3;background:rgba(255,244,179,.14)}",
".hbp-logo{width:62%;max-width:240px;height:auto;margin:8px 0 16px;filter:drop-shadow(0 2px 6px rgba(0,0,0,.5))}",
".hbp-display{font-family:'TAY Sundae','Permanent Marker',cursive;font-weight:400;text-transform:uppercase;color:#FFF4B3;font-size:clamp(2.1rem,9vw,2.9rem);line-height:.98;margin:.1em 0 .35em;text-shadow:0 2px 8px rgba(0,0,0,.35)}",
".hbp-label{font-weight:700;text-transform:uppercase;letter-spacing:.085em;color:#fff;font-size:.82rem;line-height:1.35;margin:0 0 18px;max-width:26ch}",
".hbp-step{display:none;width:100%;flex-direction:column;align-items:center}",
"#hbpOverlay[data-step='scratch'] .hbp-step[data-step='scratch'],#hbpOverlay[data-step='email'] .hbp-step[data-step='email'],#hbpOverlay[data-step='sms'] .hbp-step[data-step='sms'],#hbpOverlay[data-step='success'] .hbp-step[data-step='success']{display:flex}",
".hbp-prize{display:flex;flex-direction:column;align-items:center;justify-content:center;line-height:1;user-select:none}",
".hbp-prize .t{font-weight:700;text-transform:uppercase;letter-spacing:.04em;color:#FFF4B3;font-size:1.15rem;margin-bottom:.18em}",
".hbp-prize .b{font-weight:800;text-transform:uppercase;color:#FFF4B3;font-size:clamp(2.6rem,13vw,3.4rem)}",
".hbp-prize.inline{margin:6px 0 22px}",
".hbp-scratch{position:relative;width:100%;aspect-ratio:1.85/1;border-radius:12px;overflow:hidden;margin:2px 0 20px;background:#00070E}",
".hbp-scratch .hbp-prize{position:absolute;inset:0}",
".hbp-canvas{position:absolute;inset:0;width:100%;height:100%;touch-action:none;cursor:grab}",
".hbp-scratch.done .hbp-canvas{opacity:0;transition:opacity .45s ease;pointer-events:none}",
".hbp-form{width:100%;display:flex;flex-direction:column;gap:14px}",
".hbp-input{width:100%;border:0;border-radius:11px;background:#FFF4B3;color:#00070E;font-family:inherit;font-weight:700;text-transform:uppercase;letter-spacing:.04em;font-size:.95rem;padding:16px 18px}",
".hbp-input::placeholder{color:#00070E;opacity:.62}",
".hbp-input:focus{outline:3px solid #FBC232;outline-offset:1px}",
".hbp-btn{display:inline-flex;align-items:center;justify-content:center;width:100%;border:0;border-radius:11px;cursor:pointer;background:#FFF4B3;color:#00070E;font-family:inherit;font-weight:800;text-transform:uppercase;letter-spacing:.03em;font-size:1.12rem;padding:16px 18px;text-decoration:none;box-shadow:0 6px 0 rgba(0,0,0,.18)}",
".hbp-btn:active{transform:translateY(3px);box-shadow:0 3px 0 rgba(0,0,0,.18)}",
".hbp-claim.hide{display:none}",
".hbp-tel{display:flex;align-items:center;background:#FFF4B3;border-radius:11px;overflow:hidden}",
".hbp-cc{border:0;background:transparent;color:#00070E;font-family:inherit;font-weight:700;font-size:.95rem;padding:16px 4px 16px 14px;cursor:pointer}",
".hbp-phone{flex:1;background:transparent;border-radius:0;padding-left:8px}",
".hbp-consent{font-size:.62rem;line-height:1.4;color:rgba(255,255,255,.6);margin:12px 4px 0;text-align:center}",
".hbp-consent a{color:rgba(255,255,255,.85);text-decoration:underline}",
".hbp-skip{background:none;border:0;color:rgba(255,255,255,.55);text-decoration:underline;font-size:.78rem;cursor:pointer;font-family:inherit;margin-top:2px}"
].join("");
var style = document.createElement("style");
style.id = "hbp-style";
style.textContent = CSS;
document.head.appendChild(style);
var overlay = document.createElement("div");
overlay.id = "hbpOverlay";
overlay.setAttribute("data-step", "scratch");
overlay.setAttribute("aria-hidden", "true");
overlay.setAttribute("role", "dialog");
overlay.setAttribute("aria-modal", "true");
overlay.innerHTML =
'<div class="hbp-pop">' +
'<button class="hbp-close" type="button" aria-label="Close">&times;</button>' +
'<div class="hbp-content">' +
'<img class="hbp-logo" alt="Hot Box Pretzels" src="' + CFG.LOGO_URL + '">' +
'<section class="hbp-step" data-step="scratch">' +
'<h2 class="hbp-display">Try Your Luck</h2>' +
'<p class="hbp-label">Scratch below to see what you win</p>' +
'<div class="hbp-scratch" id="hbpScratch">' +
'<div class="hbp-prize"><span class="t">You’ve got</span><span class="b">10% OFF</span></div>' +
'<canvas class="hbp-canvas" id="hbpCanvas"></canvas>' +
'</div>' +
'<button class="hbp-btn hbp-claim hide" type="button" data-next="email">Claim</button>' +
'</section>' +
'<section class="hbp-step" data-step="email">' +
'<div class="hbp-prize inline"><span class="t">You’ve got</span><span class="b">10% OFF</span></div>' +
'<form class="hbp-form" id="hbpForm" novalidate>' +
'<input class="hbp-input" type="email" name="email" inputmode="email" placeholder="Your email address" aria-label="Your email address" required>' +
'<button class="hbp-btn" type="submit">Continue</button>' +
'</form>' +
'</section>' +
'<section class="hbp-step" data-step="sms">' +
'<h2 class="hbp-display">Finish signing up</h2>' +
'<p class="hbp-label">For texts to activate 10% off</p>' +
'<form class="hbp-form" id="hbpFormSms" novalidate>' +
'<div class="hbp-tel">' +
'<select class="hbp-cc" aria-label="Country code">' +
'<option value="+1">🇺🇸 +1</option>' +
'<option value="+1">🇨🇦 +1</option>' +
'<option value="+44">🇬🇧 +44</option>' +
'<option value="+61">🇦🇺 +61</option>' +
'<option value="+353">🇮🇪 +353</option>' +
'<option value="+64">🇳🇿 +64</option>' +
'</select>' +
'<input class="hbp-input hbp-phone" type="tel" name="phone" inputmode="tel" placeholder="Your phone number" aria-label="Your phone number">' +
'</div>' +
'<button class="hbp-btn" type="submit">Activate 10% off</button>' +
'<button class="hbp-skip" type="button" data-skip>No thanks</button>' +
'<p class="hbp-consent">By entering your number and tapping the button, you agree to receive recurring automated marketing texts (e.g. cart reminders) from Hot Box Pretzels at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help, STOP to cancel. See our <a href="/policies/terms-of-service" target="_blank" rel="noopener">Terms</a> and <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.</p>' +
'</form>' +
'</section>' +
'<section class="hbp-step" data-step="success">' +
'<h2 class="hbp-display">You are in!</h2>' +
'<p class="hbp-label">Check your email to receive your discount code.</p>' +
'<a class="hbp-btn" href="/pages/build-your-own-box">Shop now</a>' +
'</section>' +
'</div>' +
'<div class="hbp-photo"></div>' +
'</div>';
document.body.appendChild(overlay);
function setStep(s) { overlay.setAttribute("data-step", s); }
function open() { overlay.setAttribute("aria-hidden", "false"); }
function close() { overlay.setAttribute("aria-hidden", "true"); try { sessionStorage.setItem("hbp_closed", "1"); } catch (e) {} }
window.HBPPopup = { open: open, close: close };
var captured = { email: "" };
// Pretzel backend (captureLead): sends the welcome email via Resend + optional
// SMS via Twilio, and returns the authoritative discount code.
function subscribe(attrs) {
var payload = { storeId: CFG.STORE_ID, source: CFG.SOURCE, smsConsent: attrs.phone ? true : false };
if (attrs.email) payload.email = attrs.email;
if (attrs.phone) payload.phone = attrs.phone;
return fetch(CFG.CAPTURE_ENDPOINT, {
method: "POST",
headers: { "Content-Type": "application/json" },
body: JSON.stringify(payload)
}).then(function (r) {
return r.json().catch(function () { return {}; }).then(function (data) {
if (!r.ok || data.ok === false) { console.warn("[HBP] captureLead error " + r.status, data); }
else { console.log("[HBP] captureLead OK", data); }
return data || {};
});
}).catch(function (e) { console.warn("[HBP] captureLead request failed", e); return {}; });
}
// If the backend returned a code, make "Shop now" auto-apply it at checkout.
function applyCode(data) {
if (!data || !data.code) return;
try {
var shop = overlay.querySelector('.hbp-step[data-step="success"] .hbp-btn');
if (shop) shop.setAttribute("href", "/discount/" + encodeURIComponent(data.code) + "?redirect=/pages/build-your-own-box");
} catch (e) {}
}
overlay.querySelector(".hbp-close").addEventListener("click", close);
overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
overlay.querySelector('[data-next="email"]').addEventListener("click", function () { setStep("email"); });
overlay.querySelector("#hbpForm").addEventListener("submit", function (e) {
e.preventDefault();
var input = this.querySelector(".hbp-input");
if (!input.checkValidity()) { input.reportValidity(); return; }
captured.email = input.value.trim();
try { localStorage.setItem("hbp_signed", "1"); } catch (err) {}
// Defer the single captureLead call to the SMS step / skip, so the welcome
// email fires exactly once (with or without the optional phone).
setStep("sms");
});
overlay.querySelector("#hbpFormSms").addEventListener("submit", function (e) {
e.preventDefault();
var input = this.querySelector(".hbp-phone");
var cc = this.querySelector(".hbp-cc").value;
var digits = (input.value || "").replace(/\D/g, "");
var attrs = { email: captured.email };
if (digits) attrs.phone = cc + digits;
subscribe(attrs).then(applyCode);
setStep("success");
});
overlay.querySelector("[data-skip]").addEventListener("click", function () {
subscribe({ email: captured.email }).then(applyCode);
setStep("success");
});
(function () {
var box = overlay.querySelector("#hbpScratch");
var canvas = overlay.querySelector("#hbpCanvas");
var claim = overlay.querySelector(".hbp-claim");
var ctx = canvas.getContext && canvas.getContext("2d", { willReadFrequently: true });
var drawing = false, revealed = false;
function paint() {
if (!ctx) return;
var w = canvas.width, h = canvas.height, dpr = window.devicePixelRatio || 1;
ctx.globalCompositeOperation = "source-over";
ctx.clearRect(0, 0, w, h);
ctx.fillStyle = "#FFF4B3"; ctx.fillRect(0, 0, w, h);
ctx.textAlign = "center"; ctx.textBaseline = "middle";
ctx.font = "800 " + (h * 0.62) + "px 'TAY Milkbar','Baloo 2','Arial Black',sans-serif";
ctx.fillStyle = "rgba(0,7,14,.06)"; ctx.fillText("WIN", w / 2, h / 2 + h * 0.08);
ctx.font = "800 " + Math.round(22 * dpr) + "px 'TAY Milkbar','Baloo 2','Arial Black',sans-serif";
ctx.fillStyle = "rgba(0,7,14,.78)"; ctx.fillText("SCRATCH HERE", w / 2, h / 2);
}
function size() {
if (!ctx) return;
var dpr = window.devicePixelRatio || 1, r = box.getBoundingClientRect();
if (!r.width || !r.height) return;
canvas.width = Math.round(r.width * dpr); canvas.height = Math.round(r.height * dpr);
paint();
}
function pt(e) { var r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) * (canvas.width / r.width), y: (e.clientY - r.top) * (canvas.height / r.height) }; }
function erase(p) { var dpr = window.devicePixelRatio || 1; ctx.globalCompositeOperation = "destination-out"; ctx.beginPath(); ctx.arc(p.x, p.y, 26 * dpr, 0, Math.PI * 2); ctx.fill(); }
function pct() { var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data, c = 0, t = 0; for (var i = 3; i < d.length; i += 320) { t++; if (d[i] === 0) c++; } return t ? c / t : 0; }
function reveal() { if (revealed) return; revealed = true; box.classList.add("done"); claim.classList.remove("hide"); }
if (ctx) {
canvas.addEventListener("pointerdown", function (e) { if (revealed) return; drawing = true; try { canvas.setPointerCapture(e.pointerId); } catch (x) {} erase(pt(e)); e.preventDefault(); });
canvas.addEventListener("pointermove", function (e) { if (!drawing || revealed) return; erase(pt(e)); if (pct() > 0.5) reveal(); e.preventDefault(); });
window.addEventListener("pointerup", function () { if (!drawing) return; drawing = false; if (!revealed && pct() > 0.4) reveal(); });
window.addEventListener("resize", function () { if (!revealed) size(); });
}
overlay.__hbpSizeCanvas = size;
})();
function shouldShow() {
if (window.Shopify && Shopify.designMode) return false;       // not while editing in the customizer
try { if (localStorage.getItem("hbp_signed")) return false; } catch (e) {}
try { if (sessionStorage.getItem("hbp_closed")) return false; } catch (e) {}
return true;
}
function boot() {
if (!shouldShow()) return;
setTimeout(function () { open(); if (overlay.__hbpSizeCanvas) overlay.__hbpSizeCanvas(); }, CFG.DELAY_MS);
}
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
else boot();
})()
